import React from "react";
import QuoteWidget from "./QuoteWidget";
import "./landing-v2.css";

/**
 * Embeddable v2 quote form for SEO pages, service hubs, and /quote.
 * Styles are scoped under .lp2. Vehicle detail portals into
 * #lp2-vdetail-slot when present (homepage hero); otherwise inline.
 */
const QuoteEmbed = ({ className = "" }) => (
  <div className={"lp2 lp2-embed" + (className ? " " + className : "")}>
    <div className="lp2-container lp2-embed-inner">
      <QuoteWidget />
    </div>
  </div>
);

export default QuoteEmbed;
